var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3567 23.8714C25.7152 21.6489 27.1875 18.4964 27.1875 15C27.1875 8.26903 21.731 2.8125 15 2.8125C8.26903 2.8125 2.8125 8.26903 2.8125 15C2.8125 18.4964 4.28482 21.6489 6.64328 23.8714C8.82515 25.9274 11.7654 27.1875 15 27.1875C18.2346 27.1875 21.1749 25.9274 23.3567 23.8714ZM7.6814 22.2654C9.39952 20.1222 12.0395 18.75 15 18.75C17.9605 18.75 20.6005 20.1223 22.3186 22.2654C20.4503 24.1472 17.8613 25.3125 15 25.3125C12.1387 25.3125 9.54966 24.1472 7.6814 22.2654ZM19.6875 11.25C19.6875 13.8388 17.5888 15.9375 15 15.9375C12.4112 15.9375 10.3125 13.8388 10.3125 11.25C10.3125 8.66117 12.4112 6.5625 15 6.5625C17.5888 6.5625 19.6875 8.66117 19.6875 11.25Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.0f5eb19dea841bf7077310f2e40f0073.svg";
export { ForwardRef as ReactComponent };